import adMasterApi from "@/api/adMasterApi";
import authzApi from "@/api/authzApi";
import gatewayApi from "@/api/gatewayApi";
import missionApi from "@/api/missionApi";
import pregApi from "@/api/pregApi";
import rewardApi from "@/api/rewardApi";

export default {
  install(Vue) {
    Vue.prototype.adMasterApi = adMasterApi;
    Vue.prototype.authzApi = authzApi;
    Vue.prototype.gatewayApi = gatewayApi;
    Vue.prototype.missionApi = missionApi;
    Vue.prototype.pregApi = pregApi;
    Vue.prototype.rewardApi = rewardApi;
  }
}
